import { render, staticRenderFns } from "./DeliveryBill.vue?vue&type=template&id=314af8d4&scoped=true"
import script from "./DeliveryBill.vue?vue&type=script&lang=js"
export * from "./DeliveryBill.vue?vue&type=script&lang=js"
import style0 from "./DeliveryBill.vue?vue&type=style&index=0&id=314af8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314af8d4",
  null
  
)

export default component.exports